import type { ListBoardCardSelect } from 'app/components/lists/board/boardTypes'
import { RecipeCard } from 'app/components/lists/card/RecipeCard'
import { ContactJson } from 'app/types/entities'
import { HYGIENE_CARD, LEAD_CARD } from 'lib/systemCardRecipes'
import { ActionQueueDef } from './queueRegistry'
import { BoardTask } from './useBoardTasks'

export function BoardCard({
  def,
  contact,
  dragging,
  onDragStart,
  onDragEnd,
  select,
  onOpen,
  onText,
  onSnooze,
  onPress,
  tasks,
  workspaceId,
}: {
  def: ActionQueueDef
  contact: ContactJson
  dragging: boolean
  onDragStart: () => void
  onDragEnd: () => void
  /** Set while the board is picking cards for a bulk action. */
  select?: ListBoardCardSelect
  onOpen: () => void
  onText: () => void
  onSnooze: () => void
  onPress: () => void
  /** Open tasks already assigned against this contact, if any. */
  tasks?: BoardTask[]
  /** Tag colours are configured per workspace. See `Tag`. */
  workspaceId?: string
}) {
  return (
    <RecipeCard
      recipe={def.family === `lead` ? LEAD_CARD : HYGIENE_CARD}
      subject={{ kind: `contact`, contact }}
      drag={{ dragging, onDragStart, onDragEnd, select }}
      onOpen={onOpen}
      // Fires before the drawer's window-level outside-click listener; see
      // `pressedCardAt` in ContactBoardComponent.
      onPress={onPress}
      context={{ def, tasks, workspaceId, onText, onSnooze }}
    />
  )
}
